<template>
  <v-dialog
    v-model="modalAddactualite"
    persistent
    max-width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">Ajouter une actualité</span>
      </v-card-title>
      <v-card-text v-if="modalAddactualite">
        <v-container v-show="loadingstatus">
          Ajout de l’actualité en cours...
        </v-container>
        <v-container v-show="!loadingstatus">
          <v-form>
            <v-container py-0>
              <v-layout wrap>
                <v-flex
                  xs12
                  md12
                >
                  <v-switch
                    v-model="newactualite.publie"
                    color="primary"
                    label="Publier"/>
                </v-flex>
                <v-flex
                  xs12
                  md12
                >
                  <v-text-field
                    v-model="newactualite.titre"
                    class="purple-input"
                    label="Titre"
                  />
                </v-flex>
                <v-flex
                  xs12
                  md6
                >
                  <v-menu
                    v-model="menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="newactualite.datestart"
                        label="Début de l’actualité"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-on="on"
                      />
                    </template>
                    <v-date-picker
                      v-model="newactualite.datestart"
                      class="calendar"
                      no-title
                      @input="menu = false"/>
                  </v-menu>
                </v-flex>
                <v-flex
                  xs12
                  md6
                >
                  <v-menu
                    v-model="menu1"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="newactualite.dateend"
                        label="Fin de l’actualité"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-on="on"
                      />
                    </template>
                    <v-date-picker
                      v-model="newactualite.dateend"
                      class="calendar"
                      no-title
                      @input="menu1 = false"/>
                  </v-menu>
                </v-flex>
                <v-flex
                  xs12
                  md12
                >
                  <v-file-input
                    v-model="newactualite.couverture"
                    placeholder="Ajouter une image de couverture"
                    label="Couverture"
                    multiple
                    prepend-icon="mdi-paperclip"
                    accept="image/*"
                  >
                    <template v-slot:selection="{ text }">
                      <v-chip
                        small
                        label
                        color="primary"
                      >
                        {{ text }}
                      </v-chip>
                    </template>
                  </v-file-input>
                </v-flex>
                <v-flex
                  xs12
                  md12>
                  <span>Contenu de l’actualité</span>
                  <ckeditor
                    v-model="newactualite.contenu"
                    :config="configck"
                    type="classic"/>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions v-show="!loadingstatus">
        <v-spacer/>
        <v-btn
          color="warning darken-1"
          text
          @click="closeModal('Addactualite')">Annuler</v-btn>
        <v-btn
          color="primary darken-1"
          text
          @click="addActualite()">Ajouter</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  mapGetters,
  mapActions
} from 'vuex'
import { db, storage } from '@/plugins/firebase'
import moment from 'moment'

export default {
  data: () => ({
    configck: {
      language: 'fr',
      removePlugins: [ 'Heading' ],
      toolbar: [ 'bold', 'italic', 'bulletedList', 'blockQuote' ]
    },
    show: false,
    invalidlog: false,
    menu: false,
    menu1: false,
    loadingstatus: false,
    newactualite: {
      publie: false,
      datestart: '',
      dateend: '',
      titre: '',
      couverture: null,
      couverturename: '',
      contenu: ''
    },
    rules: {
      required: value => !!value || 'Champs requis.',
      min: v => v.length >= 8 || 'Min 8 caractères',
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Courriel invalide.'
      }
    }
  }),
  computed: {
    ...mapGetters(['modalAddactualite'])
  },
  methods: {
    ...mapActions(['closeModal']),
    addActualite (newactualite) { // <-- and here
      this.loadingstatus = true
      const informations = this.newactualite
      informations.creation = moment().format('YYYY-MM-DD')
      informations.dateend = moment(informations.dateend).format('YYYY-MM-DD')
      informations.datestart = moment(informations.datestart).format('YYYY-MM-DD')
      if (moment(informations.dateend).isBefore(informations.datestart)) {
        const datebefore = informations.dateend
        informations.dateend = informations.datestart
        informations.datestart = datebefore
      }
      if (this.newactualite.couverture) {
        const file = this.newactualite.couverture[0]
        storage.ref('images/' + file.name).put(file)
          .then(response => {
            response.ref.getDownloadURL().then(downloadURL => {
              informations.couverture = downloadURL
              informations.couverturename = file.name
              db.collection('actualites').add(informations)
              this.newactualite = {
                publie: false,
                datestart: '',
                dateend: '',
                titre: '',
                couverture: null,
                contenu: ''
              }
              this.loadingstatus = false
              this.closeModal('Addactualite')
            })
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        db.collection('actualites').add(informations)
        this.newactualite = {
          publie: false,
          datestart: '',
          dateend: '',
          titre: '',
          couverture: null,
          contenu: ''
        }
        this.loadingstatus = false
        this.closeModal('Addactualite')
      }
    }

  }
}
</script>

<style lang="scss">

.calendar{
  .v-btn {
      color: rgba(0, 0, 0, 0.87) !important;
      padding: 0 0 !important;
  }
  .v-btn {
    align-items: center !important;
    border-radius: 4px !important;
    display: inline-flex !important;
    flex: 0 0 auto !important;
    font-weight: 500 !important;
    letter-spacing: 0.0892857143em !important;
    justify-content: center !important;
    max-width: 100% !important;
    outline: 0 !important;
    position: relative !important;
    text-decoration: none !important;
    text-indent: 0.0892857143em !important;
    text-transform: uppercase !important;
    transition-duration: 0.28s !important;
    transition-property: box-shadow, transform, opacity !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
    user-select: none !important;
    vertical-align: middle !important;
    white-space: nowrap !important;
  }
  .v-date-picker-table .v-btn {
    z-index: auto !important;
    margin: 0 !important;
    font-size: 12px !important;
  }
  .v-date-picker-table--date td {
    width: 45px !important;
  }
  .v-btn--rounded {
    border-radius: 28px !important;
  }
  .v-date-picker-table td, .v-date-picker-table th {
      text-align: center;
      position: relative;
  }
  .v-date-picker-table--date .v-btn {
    height: 32px !important;
    width: 32px !important;
  }
  .v-btn:not(.v-btn--disabled) {
    will-change: box-shadow;
  }
  .v-btn__content {
    align-items: center !important;
    color: inherit !important;
    display: flex !important;
    flex: 1 0 auto !important;
    justify-content: inherit !important;
    line-height: normal !important;
    position: relative !important;
  }
}
</style>
